import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'

import { Heading6, SmallText } from '../styleguide'

import { CloseIcon } from './Icons'

const styles = {
  cardStyle: {
    height: '100%',
    border: '1px solid #d6d8db',
    padding: '10px 12px 16px',
    overflow: 'hidden'
  },
  containerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 7
  },
  closeButtonRootStyle: {
    minWidth: 18,
    width: 18,
    height: 18,
    color: '#acb1b6'
  }
}
const NotificationCard = ({ date, headline, teaser, classes }) => (
  <Paper className={classes.cardStyle} elevation={0}>
    <div className={classes.containerStyle}>
      <SmallText style={{ color: '#838a92' }}>
        {date[0]} &nbsp; {date[1]} Uhr
      </SmallText>
      <IconButton
        disableRipple
        classes={{ root: classes.closeButtonRootStyle }}
        onClick={() => console.log('TODO: close this notification!')}
      >
        <CloseIcon />
      </IconButton>
    </div>
    <Heading6 gutterBottom>{headline}</Heading6>
    <SmallText>{teaser}</SmallText>
  </Paper>
)

export default withStyles(styles)(NotificationCard)



// WEBPACK FOOTER //
// ./src/components/NotificationCard.js